module.exports = __webpack_public_path__ + "static/media/step_1.6a97d53a.png";